import React from "react";
import { Box } from "@mui/material";
import Footer from "./home/Footer";

const Enroll = () => {
  return (
    <>
      <Box sx={{ mt: 3 }}>
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSfHD6I90-VKNqnSBAtz8RYpEgu2h7iHhIQxLYpVwVi4OwQuig/viewform?embedded=true"
          width="100%"
          height="1503"
          frameborder="0"
          marginheight="0"
          marginwidth="0"
        >
          Loading…
        </iframe>
        <Footer />
      </Box>
    </>
  );
};

export default Enroll;
